import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useState } from "react";

export function ArtifactLogo({ className }) {
  const [imageError, setImageError] = useState(false);

  return (
    <Avatar className={className}>
      <AvatarImage
        src="/assets/email.png"
        alt="Artifact Logo"
        onError={() => {
          console.error("Failed to load RAI logo image");
          setImageError(true);
        }}
      />
      <AvatarFallback>AI</AvatarFallback>
    </Avatar>
  );
}

export default ArtifactLogo;
